import { Text, Flex, Box, Switch, Input } from '../primitives'
export const CloudMining = () => {
    return (
        <Box style={{
            zIndex: '0', display: 'grid'
        }}
            css={{
                '@sm': {
                    px: '$0',
                },
            }}

        >
            <Flex 
                css={{
                    flexWrap:'wrap',
                    alignItems: 'center',
                    zIndex: '10',
                    flexDirection: 'column',
                    gap: 36,
                    '@bp600': {
                        flexDirection: 'row',
                        gap: 0,
                    },
                }}
            >
                <Flex className='w-full lg:w-5/12 xl:w-5/12 order-2 lg:order-2 xl:order-2' justify='center' css={{ alignItems: 'flex-start', '@bp600': { alignItems: 'flex-end' } }}>
                    <Box className=" right-0 bottom-0 z-[-1] align-middle  px-4 pb-2 pt-8 order-1">
                        <img className='inset-0' src='/token/cloudMining.png' />
                    </Box>
                </Flex>
                <Box className='w-full lg:w-7/12 xl:w-7/12 order-1 lg:order-1 xl:order-1 ' css={{ alignItems: 'flex-start', px: '$1', textAlign: 'center', gap: 18, '@bp600': { alignItems: 'flex-end', gap: 8 } }}>
                    <Box className="wow fadeInUp mx-auto max-w-[800px] text-center" data-wow-delay=".2s">
                        <h3 className="text-xl lg:text-2xl xl:text-3xl font-medium leading-normal uppercase mb-4"></h3>
                        <Text className="text-2xl lg:text-4xl xl:text-2xl font-medium leading-normal uppercase">CPO Token Cloud Mining Service</Text>
                        <Box className='border-b-4 border-indigo-500 mt-5'></Box>
                        <p className="mt-4 text-base leading-relaxed text-left">
                            We are thrilled to announce that our CPO Token cloud mining services are now live and fully operational on our platform. To make this opportunity even more enticing, we are offering users a fantastic chance to kickstart their cloud mining journey with mining power ranging from 250 H/s to 549 H/s entirely free of charge.
                        </p>
                    </Box>
                    <Box className='text-left' style={{ display: 'grid' }} css={{ py: '$2', gap: 18, '@bp600': { alignItems: 'flex-end', gap: 8, flexDirection: 'row' } }}>
                    <Box className='relative grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2 xl:grid-cols-2 gap-24'>
                        <Box className='w-full'>
                            <Box className="wow fadeInUp" data-wow-delay=".15s">
                                <Box className={`wow cursor-pointer transform transition duration-500 fadeInUp relative z-10 rounded-md px-8 py-10 shadow-lg hover:border-2 hover:border-sky-500 hover:shadow-2xl hover:scale-105`} css={{ backgroundColor: '$gray3', '&:hover': { background: '$gray2', } }} data-wow-delay=".1s">
                                    <Box className='border-b border-body-color border-opacity-10 pb-4 mb-5'>
                                        <Box className="flex flex-wrap items-center justify-center">
                                            <h2 className="mb-3 text-2xl font-semibold">Free Mining Power</h2>
                                        </Box>
                                    </Box>
                                    <p>Upon enabling cloud mining in your account, you will instantly receive mining power ranging from 250 H/s to 549 H/s at no cost to you. This initial mining power allows you to start earning CPO Tokens right away.</p>
                                </Box>
                            </Box>
                        </Box>

                        <Box className='w-full'>
                            <Box className="wow fadeInUp" data-wow-delay=".15s">
                                <Box className={`wow cursor-pointer transform transition duration-500 fadeInUp relative z-10 rounded-md px-8 py-10 shadow-lg hover:border-2 hover:border-sky-500 hover:shadow-2xl hover:scale-105`} css={{ backgroundColor: '$gray3', '&:hover': { background: '$gray2', } }} data-wow-delay=".1s">
                                    <Box className='border-b border-body-color border-opacity-10 pb-4 mb-5'>
                                        <Box className="flex flex-wrap items-center justify-center">
                                            <h2 className="mb-3 text-2xl font-semibold"> Daily Earnings</h2>
                                        </Box>
                                    </Box>
                                    <p>With your allocated mining power, you can earn between 0.35 to 0.65 CPO Tokens per day. These daily earnings will be automatically credited to your account, providing you with a consistent stream of rewards.</p>
                                </Box>
                            </Box>
                        </Box>

                        <Box className='w-full'>
                            <Box className="wow fadeInUp" data-wow-delay=".15s">
                                <Box className={`wow cursor-pointer transform transition duration-500 fadeInUp relative z-10 rounded-md px-8 py-10 shadow-lg hover:border-2 hover:border-sky-500 hover:shadow-2xl hover:scale-105`} css={{ backgroundColor: '$gray3', '&:hover': { background: '$gray2', } }} data-wow-delay=".1s">
                                    <Box className='border-b border-body-color border-opacity-10 pb-4 mb-5'>
                                        <Box className="flex flex-wrap items-center justify-center">
                                            <h2 className="mb-3 text-2xl font-semibold">Supercharge Your Earnings</h2>
                                        </Box>
                                    </Box>
                                    <p>Want to boost your cloud mining earnings? You can do so by expanding your network and building your team. For every active member you bring on board, you will receive an additional 25 H/s in mining power. This means that as your team grows, so do your mining capabilities and, subsequently, your earnings.</p>
                                </Box>
                            </Box>
                        </Box>

                        <Box className='w-full'>
                            <Box className="wow fadeInUp" data-wow-delay=".15s">
                                <Box className={`wow cursor-pointer transform transition duration-500 fadeInUp relative z-10 rounded-md px-8 py-10 shadow-lg hover:border-2 hover:border-sky-500 hover:shadow-2xl hover:scale-105`} css={{ backgroundColor: '$gray3', '&:hover': { background: '$gray2', } }} data-wow-delay=".1s">
                                    <Box className='border-b border-body-color border-opacity-10 pb-4 mb-5'>
                                        <Box className="flex flex-wrap items-center justify-center">
                                            <h2 className="mb-3 text-2xl font-semibold"> Lucrative Referral Commissions</h2>
                                        </Box>
                                    </Box>
                                    <p> In addition to your mining rewards, you can earn up to 10% in referral commissions. This means that by inviting others to join our cloud mining service, you'll receive a commission on their mining activities, further enhancing your overall earnings.</p>
                                </Box>
                            </Box>
                        </Box> 

                    </Box>
                    </Box>
                </Box>

            </Flex>

        </Box>
    )
}  